module.exports = __webpack_public_path__ + "static/media/four_marker_hover.e0396026.svg";